/** @format */

import React, { useEffect, useState } from 'react';
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { loginRequestAction } from 'stateContainer/actions';
import AlertBox from 'components/Alert';
import { AiOutlineExclamationCircle } from 'react-icons/ai';
import { Spinner } from 'react-bootstrap';

export default function ChangePassword(props) {
  const text = props.t('lang_broker:changePassword');
  const change_password_route = props.t('lang_route:broker_change_password');
  const dashboard_route = props.t('lang_route:broker_dashboard');
  const dispatch = useDispatch();

  const { username, password, session, loginError, requesting } = useSelector(
    (state) => state.session
  );

  const [formError, setFormError] = useState('');

  useEffect(() => {
    if (
      loginError !== null &&
      loginError.response.data.error.code === 'InvalidPasswordException'
    )
      setFormError(text.errors.invalid_format);
  }, [loginError]);

  const formik = useFormik({
    initialValues: {
      newPassword: '',
      reenterPassword: ''
    },
    onSubmit: (values) => {
      if (!values.newPassword && !values.reenterPassword) {
        setFormError(text.errors.all_fields);
        return;
      }

      if (values.newPassword !== values.reenterPassword) {
        setFormError(text.errors.not_matching);
        return;
      }

      setFormError('');

      dispatch(
        loginRequestAction({
          username,
          password,
          newPassword: values.reenterPassword,
          session,
          successUrl: dashboard_route,
          failedUrl: change_password_route,
          changePasswordUrl: change_password_route
        })
      );
    },
    validateOnChange: false,
    validateOnBlur: false
  });

  return (
    <>
      <div className='main-container'>
        <Header {...props} />
        <div className='changepasswordpage-inner-container'>
          <Container>
            <h3>{text.heading}</h3>
            <Row>
              <Col md={8}>
                <p className='text2r changepasswordpage-description'>
                  {text.description}
                </p>
                <form
                  onSubmit={(event) => {
                    formik.handleSubmit(event);
                  }}>
                  {formError && (
                    <Row>
                      <Col>
                        <AlertBox
                          type='danger'
                          text={formError}
                          icon={<AiOutlineExclamationCircle />}
                          iconConfig={{ size: '18px' }}
                        />
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col className='changepasswordpage-field-container'>
                      <label htmlFor='newPassword' className='text3m'>
                        {text.form_label_1}
                      </label>
                      <input
                        id='newPassword'
                        name='newPassword'
                        type='password'
                        value={formik.values.newPassword}
                        onChange={formik.handleChange}
                        placeholder={text.placeholder}
                        className='changepasswordpage-field-input changepasswordpage-description'
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col className='changepasswordpage-field-container'>
                      <label htmlFor='reenterPassword' className='text3m'>
                        {text.form_label_2}
                      </label>
                      <input
                        id='reenterPassword'
                        name='reenterPassword'
                        type='password'
                        value={formik.values.reenterPassword}
                        onChange={formik.handleChange}
                        placeholder={text.placeholder}
                        className='changepasswordpage-field-input changepasswordpage-description'
                      />
                    </Col>
                  </Row>
                  <div className='changepasswordpage-button-container'>
                    <Button
                      type='submit'
                      disabled={requesting}
                      className={
                        'btn btn-pink mobile-changepasswordpage-button-width'
                      }>
                      {requesting ? (
                        <Spinner
                          animation='border'
                          role='status'
                          color='#FFFFFF'
                        />
                      ) : (
                        text.button.label
                      )}
                    </Button>
                  </div>
                </form>
              </Col>
              <Col md={{ span: 3, offset: 1 }} xs={0}>
                <img
                  src='images/image-registration-page.png'
                  className='changepasswordpage-image-1'
                  alt='registration image'
                />
              </Col>
            </Row>
          </Container>
        </div>

        <Footer {...props} />
      </div>
    </>
  );
}
